import { isIframeMode } from 'modules/taboola-common-frontend-modules/iframe/utils/isIframeMode';
import { FORM_MODES } from '../../config/formModes';
import { useFormMode } from '../../hooks';
import { useNonAuthAccess } from '../../hooks/useNonAuthAccess';
import { AppBreadcrumbs } from '../AppBreadcrumbs/AppBreadcrumbs';
import AppHeader from '../AppHeader';
import { useShowHeader } from '../AppHeader/hooks/useShowHeader';

export const AppHeaderCombined = ({ config, headerHeight, headerStyles }) => {
    const iFrameMode = isIframeMode();
    const showHeaderForModule = useShowHeader(config);
    const nonAuthAccess = useNonAuthAccess();
    const urlMode = useFormMode();
    const isCreateMode = urlMode === FORM_MODES.CREATE;
    if (!showHeaderForModule) {
        return null;
    }

    return (
        <>
            {iFrameMode && (
                <AppHeader height={headerHeight} config={config} showButtonsPanel={!iFrameMode} {...headerStyles} />
            )}
            {!nonAuthAccess && <AppBreadcrumbs accountSelectionAllowed={!iFrameMode} hidden={isCreateMode} />}
        </>
    );
};
